import { createAsyncThunk } from '@reduxjs/toolkit'
import { loginService, logoutService } from 'network/services/auth.service'
import { ROUTE_PATHS } from 'utils/constants/index'
import { signIn, signOut } from 'utils/common-services/cookie.services'
import { updatePasswordService, getRolePermissionsService } from 'network/services/admins.service' // 👈 remove checkIpWhitelistService
import { fetchUserInformation } from '../Users/User'
import { setPermissions, clearPermissions } from '../../redux/Permissions/permissionsSlice'

export const adminLogin = createAsyncThunk('Admin/login', async ({ token, email, password, setOtpRequired, navigate }, thunkApi) => {
  try {
    const res = await loginService({ token, email, password })

    // ✅ store exact role from backend — no fallback to 'admin'
    signIn({
      token: res?.accessToken,
      adminId: res?.adminId,
      role: res?.role // 👈 no fallback
    })

    // fetch permissions after login
    if (res?.adminId) {
      try {
        const permissionsRes = await getRolePermissionsService({ roleId: res?.roleId })
        const permissions = Array.isArray(permissionsRes) ? permissionsRes : permissionsRes?.data || []
        thunkApi.dispatch(setPermissions(permissions))
      } catch (err) {
        console.error('fetch permissions error:', err)
      }
    }

    navigate(ROUTE_PATHS.dashboard, { replace: true })
    thunkApi.dispatch(fetchUserInformation())
    return res
  } catch (error) {
    if (error[0]?.name === 'LoginTokenRequire') {
      setOtpRequired(true)
    }
    return thunkApi.rejectWithValue(error[0]?.description || error)
  }
})

export const adminLogout = createAsyncThunk('Admin/logout', async ({ navigate }, thunkApi) => {
  try {
    const res = await logoutService()
    signOut()
    thunkApi.dispatch(clearPermissions())
    navigate(ROUTE_PATHS.login, { replace: true })
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const updatePassword = createAsyncThunk('update/password', async ({ oldPassword, newPassword, resetForm }, thunkApi) => {
  try {
    const res = await updatePasswordService({ oldPassword, newPassword })
    resetForm()
    return res
  } catch (error) {
    resetForm()
    return thunkApi.rejectWithValue(error[0].description)
  }
})
